import React from 'react';

function NewsCard({ title, date, content }) {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <h3 className="text-lg font-semibold">{title}</h3>
      <p className="text-sm text-gray-600">{date}</p>
      <p>{content}</p>
    </div>
  );
}

export default NewsCard;